import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _dec, _dec2, _class2, _descriptor, _Class_brand;
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import Controller, { inject as controller } from "@ember/controller";
import { action, computed } from "@ember/object";
import I18n from "discourse-i18n";
let _class = (_dec = computed("pmTopicTrackingState.newIncoming.[]", "pmTopicTrackingState.statesModificationCounter", "pmTopicTrackingState.isTracking"), _dec2 = computed("pmTopicTrackingState.newIncoming.[]", "pmTopicTrackingState.statesModificationCounter", "pmTopicTrackingState.isTracking"), (_class2 = (_Class_brand = /*#__PURE__*/new WeakSet(), class _class2 extends Controller {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _Class_brand);
    _initializerDefineProperty(this, "user", _descriptor, this);
  }
  get viewingSelf() {
    return this.user.viewingSelf;
  }
  get newLinkText() {
    return _assertClassBrand(_Class_brand, this, _linkText).call(this, "new");
  }
  get unreadLinkText() {
    return _assertClassBrand(_Class_brand, this, _linkText).call(this, "unread");
  }
  get navigationControlsButton() {
    return document.getElementById("navigation-controls__button");
  }
  changeGroupNotificationLevel(notificationLevel) {
    this.group.setNotification(notificationLevel, this.get("user.model.id"));
  }
}), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "user", [controller], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "newLinkText", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "newLinkText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "unreadLinkText", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "unreadLinkText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeGroupNotificationLevel", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeGroupNotificationLevel"), _class2.prototype)), _class2));
function _linkText(type) {
  const count = this.pmTopicTrackingState?.lookupCount(type, {
    inboxFilter: "group",
    groupName: this.group.name
  });
  if (count === 0) {
    return I18n.t(`user.messages.${type}`);
  } else {
    return I18n.t(`user.messages.${type}_with_count`, {
      count
    });
  }
}
export { _class as default };